<isophi-app-portfolio-plan-base-item
  #base
  *transloco="let t"
  [leftIcon]="'linear_scale'"
  [rightIcon]="'add_2'"
  [title]="t('planDetail/linkedActivities')"
  [allowEditMode]="allowEditMode"
  (modeChange)="handleModeChanged($event)"
>
  <div *ngIf="base.isViewMode() && teacherActivityTargetLinks.length > 0" class="d-flex flex-column gap-2">
    <ng-container *ngIf="!loadingTeacherActivityTargetLinks; else loading">
      <ng-container *ngFor="let link of teacherActivityTargetLinks">
        <ng-template #linkContent>
          <div class="title">{{ link.activity.title }}</div>
          <div class="d-flex justify-content-sm-end justify-content-start type-wrap">
            <div class="activity-type fw-medium">{{ activityTypeData[link.activity.activityType] }}</div>
          </div>
          <div class="date flex-1 text-center">{{ link.activity.dateStart | date : 'd. M. y' }}</div>
          <span *ngIf="allowEditMode" class="material-symbols-rounded close-icon" (click)="handleLinkDelete(link.id, $event)">close</span>
        </ng-template>
        <a *ngIf="useAbsoluteHref" [attr.href]="buildTeacherActivityRouteLink(link.activity.id)" target="_blank" class="link-item">
          <ng-container *ngTemplateOutlet="linkContent"></ng-container>
        </a>
        <a *ngIf="!useAbsoluteHref" [routerLink]="buildTeacherActivityRouteLink(link.activity.id)" class="link-item">
          <ng-container *ngTemplateOutlet="linkContent"></ng-container>
        </a>
      </ng-container>
    </ng-container>
  </div>
  <div *ngIf="allowEditMode && base.isEditMode()" class="d-flex flex-column">
    <ng-container *ngIf="!loadingTeacherActivities; else loading">
      <ng-container *ngIf="teacherActivities.length > 0 else noActivities">
        <div class="link-select-item" *ngFor="let activity of teacherActivities">
          <div class="d-flex align-items-center gap-3 w-100 w-sm-auto checkbox-wrapper">
            <div class="form-check w-auto">
              <input
                class="form-check-input"
                type="checkbox"
                [checked]="selectedActivityUuids.includes(activity.id)"
                (change)="handleTeacherActivitySelect($event, activity.id)"
              />
            </div>
            <div class="title">{{ activity.title }}</div>
          </div>
          <div class="justify-content-sm-center justify-content-start type-wrap">
            <div class="activity-type fw-medium">{{ activityTypeData[activity.activityType] }}</div>
          </div>
          <div class="date text-end">{{ activity.dateStart | date : 'd. M. y' }}</div>
        </div>
      </ng-container>
      <ng-template #noActivities>
        <div>{{ t("planDetail/noActivities") }}</div>
      </ng-template>
    </ng-container>
  </div>
  <ng-template #loading>
    <div class="text-center">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  </ng-template>
  <div *ngIf="allowEditMode && base.isEditMode()" class="actions d-flex justify-content-end mt-4">
    <button (click)="base.setMode(base.modeEnum.VIEW)" class="btn btn-light-outline">
      {{ t('common/cancel') }}
    </button>

    <button (click)="save(); base.setMode(base.modeEnum.VIEW)" class="btn btn-primary">
      {{ t('common/save') }}
    </button>
  </div>
</isophi-app-portfolio-plan-base-item>
